import { render, staticRenderFns } from "./UmsUserStateSwitcher.vue?vue&type=template&id=65cc9133&"
import script from "./UmsUserStateSwitcher.vue?vue&type=script&lang=js&"
export * from "./UmsUserStateSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports